import { render, staticRenderFns } from "./EditPointOfSaleReceiptSettingsInline.vue?vue&type=template&id=1fc1fe5c&scoped=true&"
import script from "./EditPointOfSaleReceiptSettingsInline.vue?vue&type=script&lang=js&"
export * from "./EditPointOfSaleReceiptSettingsInline.vue?vue&type=script&lang=js&"
import style0 from "./EditPointOfSaleReceiptSettingsInline.vue?vue&type=style&index=0&id=1fc1fe5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1fe5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VForm,VIcon,VRow,VTextarea})
